<template>
  <div class="stat-card">
    <div class="card-content">
      <span class="card-label" v-html="label"></span>
      <h3 class="card-value">{{ value !== undefined && value !== null ? value : 0 }}</h3>
    </div>

    <div class="card-icon-wrapper" :class="type">
      <i :class="['fa-solid', computedIcon]"></i>
    </div>
  </div>
</template>
<script setup>
import { computed, defineProps } from 'vue'
import {piniaCompanySettingsStore} from "@/store/piniaCompanySettingsStore";

const piniaCompanySettingsState = piniaCompanySettingsStore();
const companySettings = computed(() => piniaCompanySettingsState.companySettings);

const companyColor = computed(() => companySettings.value?.colorCode || '#15803d');

const companyBgColor = computed(() => companySettings.value?.colorCode
    ? `${companySettings.value.colorCode}15`
    : '#ecfdf5'
)

const props = defineProps({
  value: {
    type: [String, Number],
    default: 0
  },
  label: {
    type: String,
    required: true
  },
  type: {
    type: String,
    default: 'default'
  }
})

const iconMap = {
  private: 'fa-user-tie',
  group: 'fa-users',
  socioTherapy: 'fa-hand-holding-heart',
  assistedLiving: 'fa-house-chimney-user',
  caseManagement: 'fa-briefcase',
  privateLearning: 'fa-graduation-cap',

  internalLocation: 'fa-building-shield',
  externalLocation: 'fa-building-user',
  otherLocation: 'fa-map-pin',

  internalUser: 'fa-user-shield',
  externalUser: 'fa-user-group',

  default: 'fa-chart-simple'
}

const computedIcon = computed(() => {
  return iconMap[props.type] || iconMap.default
})
</script>

<style scoped>

.stat-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  padding: 16px 20px;
  min-height: 100px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02), 0 1px 2px rgba(0, 0, 0, 0.04);
  transition: all 0.25s ease;
  margin-bottom: 20px;
  box-sizing: border-box;
}

.card-content {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  min-width: 0;
  margin-right: 12px;
}

.card-label {
  font-size: 0.79rem;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  line-height: 1.25;
  word-break: normal;
}

.card-value {
  font-size: 1.5rem;
  font-weight: 500;
  color: #0f172a;
  margin: 0;
  line-height: 1;
}

.card-icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 12px;
  font-size: 1.15rem;
  transition: all 0.2s ease;
  flex-shrink: 0;
  background-color: v-bind(companyBgColor) !important;
  color: v-bind(companyColor) !important;
}

.weeklySum {
  background-color: rgba(13, 148, 136, 0.08);
  color: #0d9488;
}

.section-subtitle {
  display: flex;
  align-items: center;
  font-size: 0.95rem;
  font-weight: 600;
  color: #475569;
}

.section-subtitle-icon {
  margin-right: 8px;
  color: #94a3b8;
  font-size: 0.9rem;
}

.default {
  background-color: #f1f5f9;
  color: #475569;
}



.private {
  background-color: rgba(5, 148, 72, 0.08);
  color: #059448;
}

.group {
  background-color: rgba(37, 99, 235, 0.08);
  color: #2563eb;
}

.socioTherapy {
  background-color: rgba(219, 39, 119, 0.08);
  color: #db2777;
}

.privateLearning {
  background-color: rgba(124, 58, 237, 0.08);
  color: #7c3aed;
}

.caseManagement {
  background-color: rgba(217, 119, 6, 0.08);
  color: #d97706;
}

.assistedLiving {
  background-color: rgba(244, 63, 94, 0.08);
  color: #f43f5e;
}

.internalLocation {
  background-color: rgba(16, 185, 129, 0.08);
  color: #10b981;
}

.externalLocation {
  background-color: rgba(59, 130, 246, 0.08);
  color: #3b82f6;
}

.otherLocation {
  background-color: rgba(100, 116, 139, 0.08);
  color: #64748b;
}

.internalUser {
  background-color: rgba(37, 99, 235, 0.08);
  color: #2563eb;
}

.externalUser {
  background-color: rgba(139, 92, 246, 0.08);
  color: #8b5cf6;
}

@media  (max-width: 1550px) {
  .card-label {
    font-size: 0.7rem;
  }

  .card-value {
    font-size: 0.9rem;
  }

  .card-icon-wrapper {
    width: 36px;
    height: 36px;
    font-size: 1rem;
  }
}

</style>